import React from 'react';

import styles from './IncomeDisclaimerNote.module.scss';

export const INCOME_DISCLAIMER_TEXT =
  'Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation.';

const IncomeDisclaimerNote = () => <p className={styles.note}>{INCOME_DISCLAIMER_TEXT}</p>;

export default IncomeDisclaimerNote;
